export default "__VITE_ASSET__CBgTYs9R__"